import type {SVGProps} from 'react'

const SvgCo2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={24}
    height={24}
    fill={'none'}
    viewBox={'0 0 24 24'}
    {...props}
  >
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M11.5 5.625a5.876 5.876 0 0 0-5.823 5.086l-.026.194-.132.145a4.375 4.375 0 0 0 3.23 7.325h8.001a3.875 3.875 0 0 0 .954-7.632l-.377-.095-.081-.38A5.88 5.88 0 0 0 11.5 5.625m-7.033 4.729A7.127 7.127 0 0 1 18.38 9.64a5.127 5.127 0 0 1-1.63 9.985h-8a5.625 5.625 0 0 1-4.283-9.271'}
      clipRule={'evenodd'}
    />
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M11.115 12.164a1.79 1.79 0 0 1 3.579 0v1.165a1.79 1.79 0 0 1-3.579 0zm1.79-.539a.54.54 0 0 0-.54.54v1.164a.54.54 0 0 0 1.079 0v-1.165a.54.54 0 0 0-.54-.539M7.125 12.164c0-.988.801-1.789 1.79-1.789h.29c.828 0 1.499.67 1.499 1.498h-1.25a.25.25 0 0 0-.249-.248h-.29a.54.54 0 0 0-.54.54v1.164c0 .298.241.54.54.54h.29a.25.25 0 0 0 .249-.25h1.25c0 .828-.671 1.5-1.499 1.5h-.29a1.79 1.79 0 0 1-1.79-1.79zM16.065 14.045a.42.42 0 1 1 .708.304l-1.154.99.173.179h-.257v.54H17.5v-.54h-1.35l1.013-.76c.643-.612.21-1.697-.679-1.697a.984.984 0 0 0-.984.984v.036h.565z'}
      clipRule={'evenodd'}
    />
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'m15.35 15.33-.004-.005 1.3-1.115a.232.232 0 1 0-.393-.165v.223h-.94v-.223c0-.647.524-1.171 1.171-1.171 1.058 0 1.574 1.29.808 2.02l-.008.007-.571.43h.974v.915h-2.34v-.916z'}
      clipRule={'evenodd'}
    />
  </svg>
)
export default SvgCo2
